"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isValidQuantity = void 0;
const isValidQuantity = (value)=>value !== '' && value !== '-';
exports.isValidQuantity = isValidQuantity;
